  <mat-toolbar class="mat-elevation-z2">
    <mat-toolbar-row>
      <div id="top-menu">
        @if ($org()) {
            @let org = $org();
            <a class="dual-logo" routerLink="/" title="risr/apply">
            <img [src]="org.themeSetup?.logoDesktopPath" [alt]="org.name" class="logo-desktop" />
            <img [src]="org.themeSetup?.logoMobilePath || org.themeSetup?.logoDesktopPath" [alt]="org.name"
                class="logo-mobile" />
            <img src="assets/images/main-logo-append.png" alt="risr apply" />
            </a>
        }
        <span class="main-nav-links" *ngIf="!(isHandset$ | async)">
          <ng-container *ngFor="let item of menu()">
            <a *ngIf="item.link" routerLink="{{item.link}}">{{ item.title }}</a>
            <a *ngIf="item.abslink" href="{{item.abslink}}" target="_blank">{{ item.title }}</a>
            <span *ngIf="(item.subitems ?? []).length">
              <a [matMenuTriggerFor]="appMenu">
                {{ item.title }}
                <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true">arrow_drop_down</mat-icon>
              </a>
              <mat-menu #appMenu="matMenu" yPosition="below" [overlapTrigger]="false">
                <a mat-menu-item *ngFor="let subitem of item.subitems" routerLink="{{subitem.link}}">{{ subitem.title
                  }}</a>
              </mat-menu>
            </span>
          </ng-container>
        </span>
        <span class="spacer"></span>
        <span>
          <eas-buttons-menu
            [aria-label]="'Languages menu'"
            [buttons]="languagesButtonsButtons"
            [options]="{isClosedSVGIcon: true, closed: 'M448 164C459 164 468 172.1 468 184V188H528C539 188 548 196.1 548 208C548 219 539 228 528 228H526L524.4 232.5C515.5 256.1 501.9 279.1 484.7 297.9C485.6 298.4 486.5 298.1 487.4 299.5L506.3 310.8C515.8 316.5 518.8 328.8 513.1 338.3C507.5 347.8 495.2 350.8 485.7 345.1L466.8 333.8C462.4 331.1 457.1 328.3 453.7 325.3C443.2 332.8 431.8 339.3 419.8 344.7L416.1 346.3C406 350.8 394.2 346.2 389.7 336.1C385.2 326 389.8 314.2 399.9 309.7L403.5 308.1C409.9 305.2 416.1 301.1 422 298.3L409.9 286.1C402 278.3 402 265.7 409.9 257.9C417.7 250 430.3 250 438.1 257.9L452.7 272.4L453.3 272.1C465.7 259.9 475.8 244.7 483.1 227.1H376C364.1 227.1 356 219 356 207.1C356 196.1 364.1 187.1 376 187.1H428V183.1C428 172.1 436.1 163.1 448 163.1L448 164zM160 233.2L179 276H140.1L160 233.2zM0 128C0 92.65 28.65 64 64 64H576C611.3 64 640 92.65 640 128V384C640 419.3 611.3 448 576 448H64C28.65 448 0 419.3 0 384V128zM320 384H576V128H320V384zM178.3 175.9C175.1 168.7 167.9 164 160 164C152.1 164 144.9 168.7 141.7 175.9L77.72 319.9C73.24 329.1 77.78 341.8 87.88 346.3C97.97 350.8 109.8 346.2 114.3 336.1L123.2 315.1H196.8L205.7 336.1C210.2 346.2 222 350.8 232.1 346.3C242.2 341.8 246.8 329.1 242.3 319.9L178.3 175.9z'}"></eas-buttons-menu>
        </span>
        <span>
          @if (currentUser().username === 'anonymous') {
              <button type="button" mat-button (click)="login()">Login</button>
          } @else {
              {{ (currentUser()).originalProfile?.fullName || currentUser().username }}
          }
        </span>
        <!-- <span *ngIf="!(isHandset$ | async)">
          <eas-buttons-menu
            [aria-label]="'Languages menu'"
            [buttons]="languagesButtonsButtons"
            [options]="{isClosedSVGIcon: true, closed: 'M448 164C459 164 468 172.1 468 184V188H528C539 188 548 196.1 548 208C548 219 539 228 528 228H526L524.4 232.5C515.5 256.1 501.9 279.1 484.7 297.9C485.6 298.4 486.5 298.1 487.4 299.5L506.3 310.8C515.8 316.5 518.8 328.8 513.1 338.3C507.5 347.8 495.2 350.8 485.7 345.1L466.8 333.8C462.4 331.1 457.1 328.3 453.7 325.3C443.2 332.8 431.8 339.3 419.8 344.7L416.1 346.3C406 350.8 394.2 346.2 389.7 336.1C385.2 326 389.8 314.2 399.9 309.7L403.5 308.1C409.9 305.2 416.1 301.1 422 298.3L409.9 286.1C402 278.3 402 265.7 409.9 257.9C417.7 250 430.3 250 438.1 257.9L452.7 272.4L453.3 272.1C465.7 259.9 475.8 244.7 483.1 227.1H376C364.1 227.1 356 219 356 207.1C356 196.1 364.1 187.1 376 187.1H428V183.1C428 172.1 436.1 163.1 448 163.1L448 164zM160 233.2L179 276H140.1L160 233.2zM0 128C0 92.65 28.65 64 64 64H576C611.3 64 640 92.65 640 128V384C640 419.3 611.3 448 576 448H64C28.65 448 0 419.3 0 384V128zM320 384H576V128H320V384zM178.3 175.9C175.1 168.7 167.9 164 160 164C152.1 164 144.9 168.7 141.7 175.9L77.72 319.9C73.24 329.1 77.78 341.8 87.88 346.3C97.97 350.8 109.8 346.2 114.3 336.1L123.2 315.1H196.8L205.7 336.1C210.2 346.2 222 350.8 232.1 346.3C242.2 341.8 246.8 329.1 242.3 319.9L178.3 175.9z'}"></eas-buttons-menu>
        </span>
        <span *ngIf="!(isHandset$ | async)">
          <span *ngIf="(currentUser$ | async).original; let original"><strong i18n>{{ original.fullName }} masquerading as</strong></span>
          <a *ngIf="profile$ | async; let profile" routerLink="/users/profile/view">{{ profile.fullname }}</a>
        </span>
        <eas-buttons-menu
          [aria-label]="'Logout menu'"
          [buttons]="avatarButtons"
          [options]="{closed: 'more_vert'}">
        </eas-buttons-menu> -->
      </div>
    </mat-toolbar-row>

  </mat-toolbar>

  <main id="app-main">
    <ng-content></ng-content>
  </main>
